import { Card, CardBody, Col, Label } from "reactstrap";
import CommonToggleHeader from "../Common/CommonToggleHeader";
import { TransactionHistorys } from "../../../../Constant";
import { TransactionHistoryTable } from "./TransactionHistoryTable";

const TransactionHistory = () => {
  return (
    <Col xl="6" sm="12" className="box-col-6">
      <Card className="position-relative">
        <CommonToggleHeader title={TransactionHistorys} />
        <CardBody className="pt-0 transaction-card mb-1">
          <div className="table-responsive theme-scrollbar">
            <div id="transaction_wrapper" className="dataTables_wrapper no-footer">
              <div id="transaction_filter" className="dataTables_filter">
                <Label>Search:<input type="search"/></Label>
              </div>
              <TransactionHistoryTable />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TransactionHistory;
